import { useLocation } from "react-router-dom";

export default function Footer() {
  const { pathname } = useLocation();
  return (
    <footer className="foot">
      <div className="wrap">
        <p>
          <strong>Product &amp; Availability:</strong> Availability, options, quantities and prices are confirmed after
          your inquiry. Photos are for reference and packaging/colours may vary. Adding an item does not reserve or
          purchase it.
        </p>
        {pathname !== "/cart" && <p>Choose any available size, shade, scent, colour, or other selection before adding.</p>}
      </div>
    </footer>
  );
}
